import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];

  connect() {
    const title = this.data.get("title") || this.element.innerText;
    const data = {
      title: title,
      sf_symbol: this.data.get("sf-symbol"),
      url: this.element.getAttribute("href"),
      script: this.data.get("script"),
    };
    this.setPrimaryAction(data);
  }

  disconnect() {
    this.setPrimaryAction();
  }

  setPrimaryAction(data = {}) {
    try {
      const showsNothing = data.title === undefined && data.sf_symbol === undefined;
      const doesNothing = data.url === undefined && data.script === undefined;
      if (showsNothing || doesNothing) {
        console.log("setupPrimaryAction", showsNothing ? "shows nothing" : "", doesNothing ? "does nothing" : "");
        return;
      }

      if (typeof androidApp !== "undefined") {
        androidApp.setupPrimaryAction(data.title, data.sf_symbol, data.url, data.script);
        this.element.classList.add("hidden");
      } else if (typeof webkit !== "undefined" && typeof webkit.messageHandlers !== "undefined") {
        webkit.messageHandlers.setupPrimaryAction.postMessage(data);
        this.element.classList.add("hidden");
      } else {
        this.insertBrowserPrimaryActionButton(data);
      }
    } catch (error) {
      console.error("PrimaryActionController: ", error);
    }
  }

  insertBrowserPrimaryActionButton(data) {
    if (!data.url && !data.script) {
      console.error("PrimaryActionController: No URL or script provided");
      return;
    }

    let element;

    if (data.url) {
      element = document.createElement("a");
      element.href = data.url;
    } else {
      element = document.createElement("button");
      element.setAttribute("onclick", data.script);
      element.setAttribute("type", "button");
    }

    if (data.sf_symbol) {
      this.loadIcon(data.sf_symbol, svg => {
        element.innerHTML = svg.replace("<svg", "<svg class=\"fill-current text-detail-2 w-[30px] h-[30px]\"") + "<span class='sr-only'>" + data.title + "</span>";
        this.element.insertAdjacentElement('afterend', element);
        this.element.classList.add("hidden");
      });
    } else {
      element.innerText = data.title;
      element.setAttribute('class', this.element.getAttribute('class'));
      this.element.insertAdjacentElement('afterend', element);
      this.element.classList.add("hidden");
    }
  }

  loadIcon(name, callback) {
    const iconPaths = JSON.parse(document.documentElement.dataset.sfIcons);
    fetch(iconPaths[name]).then(response => response.text()).then(callback);
  }
}
